import pick from 'utils/pick';

const pickedKeys = ['backgroundColor', 'backgroundImage', 'styleName'];

/**
 * Gets page specification properties.
 * @param {object} page Parabo page or page style
 * @returns {object}
 */
const getPageSpec = page => {
  return pick(page, ...pickedKeys);
};

export default getPageSpec;
